// Toast notifications. Injects transient success/error/info messages into the
// [data-toaster] live region. Public API: window.theme.toast(msg, {type, duration}).
// Also listens for a "toast:show" document CustomEvent so any script / inline
// Liquid can fire one with no JS dependency. Loaded (defer) after theme-base.js.
window.theme = window.theme || {};
(function (t) {
  var MAX = 3;
  var open =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICONS = {
    success: open + '<path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>',
    error: open + '<circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>',
    info: open + '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>',
    close: open + '<path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
  };

  function container() { return document.querySelector("[data-toaster]"); }

  function readStrings() {
    var d = (container() && container().dataset) || {};
    return {
      atcError: d.msgAtcError || "",
      cartError: d.msgCartError || "",
      wishlistAdded: d.msgWishlistAdded || "",
      wishlistRemoved: d.msgWishlistRemoved || "",
      discountApplied: d.msgDiscountApplied || "",
      dismiss: d.msgDismiss || "Dismiss",
    };
  }
  t.strings = readStrings();

  function remove(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }

  function dismiss(el) {
    if (!el || el.dataset.leaving) return;
    el.dataset.leaving = "1";
    if (el._timer) { clearTimeout(el._timer); el._timer = null; }
    el.classList.remove("is-shown");
    el.classList.add("is-leaving");
    var fell = false;
    el.addEventListener("transitionend", function () { fell = true; remove(el); }, { once: true });
    setTimeout(function () { if (!fell) remove(el); }, 400); // fallback when no transition runs (reduced motion / fixture)
  }

  function schedule(el, duration) {
    el._remaining = duration;
    var start;
    function run() { start = Date.now(); el._timer = setTimeout(function () { dismiss(el); }, el._remaining); }
    function pause() {
      if (!el._timer) return;
      clearTimeout(el._timer); el._timer = null;
      el._remaining = Math.max(0, el._remaining - (Date.now() - start));
    }
    el.addEventListener("mouseenter", pause);
    el.addEventListener("mouseleave", run);
    el.addEventListener("focusin", pause);
    el.addEventListener("focusout", run);
    run();
  }

  function build(message, type) {
    var el = document.createElement("div");
    el.className = "jg-toast jg-toast--" + type;
    if (type === "error") el.setAttribute("role", "alert");

    var icon = document.createElement("span");
    icon.className = "jg-toast__icon";
    icon.innerHTML = ICONS[type] || ICONS.info;

    var msg = document.createElement("span");
    msg.className = "jg-toast__msg";
    msg.textContent = message; // textContent = safe against markup in untrusted server messages

    var close = document.createElement("button");
    close.type = "button";
    close.className = "jg-toast__close";
    close.setAttribute("aria-label", t.strings.dismiss);
    close.innerHTML = ICONS.close;
    close.addEventListener("click", function () { dismiss(el); });

    el.appendChild(icon);
    el.appendChild(msg);
    el.appendChild(close);
    return el;
  }

  function show(message, opts) {
    if (!message) return null;
    var c = container();
    if (!c) return null; // no-op when the toaster snippet isn't on the page
    opts = opts || {};
    var type = opts.type || "info";
    if (type !== "success" && type !== "error" && type !== "info") type = "info";
    var duration = Number(opts.duration) || Number(c.dataset.duration) || 4000;

    var alive = c.querySelectorAll(".jg-toast:not(.is-leaving)");
    for (var i = 0; i <= alive.length - MAX; i++) dismiss(alive[i]); // keep at most MAX

    var el = build(message, type);
    c.appendChild(el);
    void el.offsetWidth; // reflow so the enter transition runs
    el.classList.add("is-shown");
    schedule(el, duration);
    return el;
  }

  t.toast = show;
  document.addEventListener("toast:show", function (e) {
    var d = (e && e.detail) || {};
    show(d.message, { type: d.type, duration: d.duration });
  });
})(window.theme);
